import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocationsService } from './services/locations/locations.service';
import { Store } from '@ngrx/store';
import { IvvaStore } from './store/store.model';
import OFFERS_ACTIONS from './store/offers/offers.actions';
import { ToastsService } from './services/toasts/toasts.service';
import { OffersService } from './services/offers/offers.service';
import { PopupService } from './services/popup/popup.service';
import { Popup } from './services/popup/popup.model';
import { DialogComponent } from '@toevla/ui';

@Component({
    imports: [RouterModule, DialogComponent],
    selector: 'ivva-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
	popup = signal<Popup | null>(null);
	showPopup = signal<boolean>(false);

	readonly #locationsService = inject(LocationsService);
	readonly #offersService = inject(OffersService);
	readonly #popupService = inject(PopupService);
	readonly #store = inject(Store<IvvaStore>);
	readonly #toastsService = inject(ToastsService);
	readonly #translate = inject(TranslateService);

	constructor() {
		const language = 'nl';
		this.#translate.setDefaultLang(language);
		this.#translate.use(language);
	}

	ngOnInit() {
		this.#locationsService.initLocations().subscribe({
			next: (locations) => this.#store.next(OFFERS_ACTIONS.setLocations({ locations })),
			error: (res) => this.#toastsService.serverError(res, 'TOAST.FAILED_TO_GET_LOCATIONS'),
		});

		this.#offersService.getMaxPrices().subscribe((data) => this.#store.next(OFFERS_ACTIONS.setMaxPrices(data)));

		this.#popupService.getLatestPopup().subscribe((popup) => {
			if (popup) {
				this.checkShowPopup(popup);
			}
		});
	}

	hidePopup() {
		const popup = this.popup();

		if (popup) {
			localStorage.setItem('popup', popup.lastEditedOn);
			this.showPopup.set(false);
		}
	}

	private checkShowPopup(popup: Popup) {
		const lastShown = localStorage.getItem('popup');

		if (!lastShown || lastShown !== popup.lastEditedOn) {
			this.popup.set(popup);
			this.showPopup.set(!!popup);
		}
	}
}
